import React, { useEffect, useState } from 'react'
import Select from "react-select";
import no_image_available from "../../../assets/images/no_image_available.png";
import { packageService } from '../../../services/packageService';
import BookingPackage from './BookingPackage';

const BookingTrip = ({
  errors,
  options,
  t,
  watch,
  setValue,
  urlConfig,
  reset,
  setAddons,
  setSelectedAddons,
  isEditMode
}) => {
  const [packages, setPackages] = useState(null);

  useEffect(() => {
    if (!watch("tripId")) {
      setPackages(null);
    }
  },[watch("tripId")]);
   useEffect(() => {
    if (isEditMode && watch("tripId")) {
      handleTrip(watch("tripId"))
    }
  },[]);
  const handleTrip = async (tripId) => {
    try {
      var data = await packageService.getTripPackages(tripId);
      setPackages(data);
      reset(
        {
          packageId: "",
        },
        {
          keepValues: true,
          keepErrors: true,
          keepDirty: true,
        },
      );
    } catch (error) {}
  };
  const setSelectedPackage = async (packageId) => {
    try {
     setAddons(packages?.find((p) => p.packageId === packageId)?.addons || []);
     setSelectedAddons([]); // 🔥 RESET OLD SELECTION
    } catch (error) {}
  };
   useEffect(() => {
    if (watch("packageId")) {
      setSelectedPackage(watch("packageId"));
    }
  },[watch("packageId")]);
  return (
    <>
      <div className="col-12">
        <div className="form-group">
          <label className="form-label">{t("selectTrip")}</label>
          <Select
            options={options}
            value={
              options
                ?.map((s) => ({
                  value: s.value,
                  label: s.label,
                  image: s.image,
                }))
                .find((c) => c.value === watch("tripId")) || null
            }
            placeholder={t("selectTrip")}
            onChange={(option) => {
              setValue("tripId", option?.value, {
                shouldValidate: true,
              });
            }}
            formatOptionLabel={(option, { context }) => {
              // Selected value UI
              if (context === "value") {
                return (
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        option.image
                          ? `${urlConfig.imageBaseUrl}/${option.image}`
                          : no_image_available
                      }
                      width="28"
                      height="28"
                      style={{
                        borderRadius: "50%",
                        marginInlineEnd: 8,
                        objectFit: "cover",
                      }}
                    />
                    <span>{option.label}</span>
                  </div>
                );
              }

              // Dropdown list UI
              return (
                <div
                  className="d-flex align-items-center"
                  onClick={() => handleTrip(option.value)}
                >
                  <img
                    src={
                      option.image
                        ? `${urlConfig.imageBaseUrl}/${option.image}`
                        : no_image_available
                    }
                    width="45"
                    height="45"
                    style={{
                      borderRadius: 8,
                      marginInlineEnd: 10,
                      objectFit: "cover",
                    }}
                  />

                  <div>
                    <div style={{ fontWeight: 500 }}>{option.label}</div>

                    <small style={{ color: "#666" }}>{option.city}</small>
                  </div>
                </div>
              );
            }}
          />
          {errors.tripId && (
            <p className="text-danger">{errors.tripId.message}</p>
          )}
        </div>
      </div>
      <BookingPackage
        packages={packages}
        errors={errors}
        t={t}
        watch={watch}
        setValue={setValue}
      />
    </>
  );
};

export default BookingTrip